let session = {
  getItem: () => null,
  setItem: () => null,
} as unknown as Storage;

try {
  session = window.sessionStorage;
} catch (e) {
  // do nothing
}

export const SessionStorage = {
  get(key: string) {
    const item = session.getItem(key);
    if (!item) return null;

    return JSON.parse(item);
  },
  set(key: string, value: unknown) {
    const obj = JSON.stringify(value);
    return session.setItem(key, obj);
  },
  remove(key: string) {
    return session.removeItem(key);
  },
};
